import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormPentagon: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconFormPentagon"><Path d="M10.3828 2.24755C11.3465 1.54753 12.6515 1.54753 13.6152 2.24755L20.7744 7.4497C21.7381 8.14999 22.1416 9.39092 21.7734 10.5239L19.039 18.9409C18.6707 20.0735 17.6149 20.8403 16.4238 20.8403H7.5742C6.38313 20.8403 5.32735 20.0735 4.95897 18.9409L2.22459 10.5239C1.85646 9.39093 2.25991 8.14999 3.22362 7.4497L10.3828 2.24755Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFormPentagon;
